module.exports = "#define GLSLIFY 1\nvarying vec2 vUv;\nvarying vec3 vPosition;\nvoid main() {\n  vUv = uv;\n  vPosition = position;\n\n  gl_Position = projectionMatrix * modelViewMatrix  * vec4(position, 1.0);\n}"


//////////////////
// WEBPACK FOOTER
// ./three/shaders/fishbach_bg.vert
// module id = 361
// module chunks = 0